import { IMAGES } from "../../data/tilio";
import { Reveal } from "./Shared";

export default function Hosts() {
    return (
        <section data-testid="hosts-section" className="border-t border-stone/70 bg-white">
            <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-6 py-24 lg:grid-cols-2 lg:gap-20 lg:px-10 lg:py-32">
                <Reveal className="order-2 lg:order-1">
                    <p className="overline-label" data-testid="hosts-eyebrow">07 — Poznaj gospodarzy</p>
                    <h2 className="mt-5 font-serif text-[clamp(2.1rem,1.2rem+2.4vw,3.9rem)] leading-[1.08] tracking-[-1.2px] text-pine" data-testid="hosts-title">
                        Ludzie, dla których Tilio jest domem, nie tylko biznesem.
                    </h2>
                    <p className="mt-5 max-w-sm text-[17px] leading-[1.6] text-sage md:text-lg">
                        Tilio powstało z miłości do przyrody i potrzeby życia trochę wolniej — z dala od
                        pośpiechu i hałasu miasta. Agnieszka znalazła tutaj spokój, którego szukała.
                        Ciche poranki, zachody słońca nad lasem i żurawie, które budzą rano, szybko stały
                        się jej codziennością. Mieszkają tu też pieski. Hesia i Tutu były pierwsze,
                        a jakiś czas temu dołączył do nich Atos — niewidomy, który po prostu się tu
                        przybłąkał i już został. To miejsce stało się domem nie tylko dla Agnieszki,
                        ale dla każdego, kto chce choć na chwilę zwolnić.
                    </p>
                    <p className="mt-4 max-w-sm text-[17px] leading-[1.6] text-sage md:text-lg">
                        Zawsze jesteśmy w pobliżu — podpowiemy trasę spływu, rozpalimy saunę
                        i zostawimy Wam tyle przestrzeni, ile potrzebujecie.
                    </p>
                    <p className="mt-10 font-serif text-3xl italic tracking-tight text-pine" data-testid="hosts-signature">
                        Agnieszka
                    </p>
                </Reveal>
                <Reveal delay={0.15} className="order-1 lg:order-2">
                    <div className="relative">
                        <img
                            src={IMAGES.hosts}
                            alt="Agnieszka – gospodyni Tilio, domki nad Liwcem na Mazowszu"
                            data-testid="hosts-image"
                            loading="lazy"
                            className="aspect-[4/5] w-full object-cover object-center"
                        />
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
